import { useEffect, useRef } from 'react';
import { useNetworkElementsStore } from '../store/networkElementsStore';

// Full network reload while a details panel is open. 15 s (was 5 s): every reload fetches
// and validates the whole zone; element edits arrive via SSE anyway, the poll only refreshes
// slowly changing Stammdaten/SMGW fields of the selected element.
export function useNetworkDataPolling(pollInterval: number = 15000) {
  const loadElements = useNetworkElementsStore(state => state.loadElements);
  const isPendingUpdateRef = useRef(false);

  // Function to mark the start of a local update
  const markPendingUpdate = () => {
    isPendingUpdateRef.current = true;
  };

  // Function to mark the end of a local update
  const clearPendingUpdate = () => {
    isPendingUpdateRef.current = false;
  };

  useEffect(() => {
    // Initial load
    loadElements();

    // Set up polling
    const interval = setInterval(() => {
      // Skip polling if there's a pending update
      if (!isPendingUpdateRef.current) {
        loadElements();
      }
    }, pollInterval);

    // Cleanup
    return () => clearInterval(interval);
  }, [loadElements, pollInterval]);

  return {
    markPendingUpdate,
    clearPendingUpdate
  };
}
